import { useState, useEffect } from 'react';
import { initMatomo, acceptMatomoCookies } from '../utils/analytics';

export default function CookieBanner({
  matomoUrl = 'https://analytics.valentin-fiess.fr',
  siteId = '2',
}) {
  const [isVisible, setIsVisible] = useState(() => typeof window !== 'undefined' ? !localStorage.getItem('cookie_consent') : false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (consent === 'accepted') {
      try {
        initMatomo(matomoUrl, siteId);
        acceptMatomoCookies();
      } catch {
        // noop
      }
    }
  }, [matomoUrl, siteId]);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');

    try {
      initMatomo(matomoUrl, siteId);
      acceptMatomoCookies();
    } catch {
      // noop
    }

    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-slide-up">
        <div className="mx-auto max-w-3xl px-4 pb-8 pt-6">
          <div className="rounded-2xl bg-stone-900 p-6 shadow-2xl ring-1 ring-white/10 sm:p-8">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
              <div className="space-y-2">
                <h3 className="text-lg font-semibold text-white">
                  🍪 Nous respectons votre vie privée
                </h3>
                <p className="text-sm leading-relaxed text-stone-300">
                  Nous utilisons des cookies Matomo pour mesurer notre audience et améliorer notre service.
                  Les cookies techniques Cloudflare sont strictement nécessaires à la sécurité et exemptés
                  de consentement. Vous pouvez accepter ou refuser librement.
                </p>
              </div>
              <div className="flex shrink-0 items-center gap-2 sm:flex-col sm:items-stretch">
                <button
                  onClick={handleAccept}
                  className="rounded-xl bg-[#A43032] px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-[#A43032]/30 transition-all hover:bg-[#8d282a] hover:shadow-xl hover:shadow-[#A43032]/40 active:scale-[0.98]"
                >
                  Accepter
                </button>
                <button
                  onClick={handleDecline}
                  className="px-3 py-3 text-xs text-stone-500 transition-colors hover:text-stone-400 sm:self-center"
                >
                  Refuser
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
}
